module.exports = __webpack_public_path__ + "media/onboarding/light-bulb-icon-2dfc0468.png";